// utils/getPublicIP.js

const getPublicIP = async () => {
  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const { ip } = await res.json();
    return ip;
  } catch (err) {
    console.error('Failed to fetch IP:', err);
    return null;
  }
};

export default getPublicIP;